import { z } from 'zod';

import { calculateAge } from '@/helpers/profileHelpers';

export const GetStartedFormSchema = z.object({
    firstName: z.string().min(1, { message: 'First name is required' }),
    dateOfBirth: z.date().nullable().refine(
        (date) => {
            if (!date) return false;
            const age = calculateAge(date);
            return age >= 5 && age <= 120;
        },
        { message: 'Date of birth must be valid (MM/DD/YYYY)' },
    ),
    currentUsStateOrTerritoryId: z.string().min(1, { message: 'State is required' }),
    agreedToLegal: z.boolean().refine(value => value),
    agreedToMarketingUse: z.boolean().optional(),
});
